import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

import Iconify from '../../../../theme/iconify/iconify';

const Explanation = ({ explanation, mb }) => {
    const { t } = useTranslation();

    return (
        <FormHelperText component='div' sx={{
            ml: {
                xs: 0,
                md: 3.5
            },
            mr: {
                xs: 0
            },
            mt: -0.5,
            mb: mb ? 0 : 1,
            fontSize: '0.9rem',
            color: 'error.main',
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            borderRadius: '8px',
            p: 1.5
        }}>
            <Grid container alignItems='center'>
                <Grid item md={1} xs={12} sx={{ display: 'flex', justifyContent: 'center', mb: 0.5, pr: 1 }}>
                    <Iconify icon='lucide:bot' width={32} />
                </Grid>
                <Grid item xs={11}>
                    <Typography variant='h6' sx={{ fontSize: '0.9rem !important' }}>
                        {t('course.quiz.explanation')}
                    </Typography>
                    <Typography variant='body2' sx={{ fontSize: '0.9rem' }}>
                        {explanation}
                    </Typography>
                </Grid>
            </Grid>
        </FormHelperText>
    );
}

export const LoadingExplanation = () => {
    return (
        <FormHelperText sx={{ ml: 3.5, mt: 0, fontSize: '0.9rem', color: 'error.main' }}>
            <Iconify
                icon='svg-spinners:3-dots-fade'
                style={{
                    display: 'flex',
                    alignSelf: 'flex-end',
                    marginLeft: 1,
                    marginBottom: 1,
                }}
            />
        </FormHelperText>
    );
}

export default Explanation;